import { render, staticRenderFns } from "./PanelBox.vue?vue&type=template&id=587317fb&scoped=true"
import script from "./PanelBox.vue?vue&type=script&lang=js"
export * from "./PanelBox.vue?vue&type=script&lang=js"
import style0 from "./PanelBox.vue?vue&type=style&index=0&id=587317fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587317fb",
  null
  
)

export default component.exports